import CardGlossary from './CardGlossary';

export default CardGlossary;
